(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-horizontal-alternative"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const parentLinks = document.querySelectorAll('.menu-alternative a[data-has-children]');
    const childMenus = document.querySelectorAll('.menu-navigation__child-list');

    const resetMenus = () => {
      parentLinks.forEach((link) => link.setAttribute('aria-expanded', 'false'));
      childMenus.forEach((menu) => menu.classList.remove('active'));
    };

    const activateMenu = (link, menu) => {
      if (link) link.setAttribute('aria-expanded', 'true');
      if (menu) menu.classList.add('active');
    };

    const getHandle = (element) => element?.dataset.handle || '';

    const handleHover = (link) => {
      if (!link) return;
      const handle = getHandle(link);
      const matchingMenu = [...childMenus].find((menu) => getHandle(menu) === handle);

      resetMenus();
      activateMenu(link, matchingMenu);
    };

    parentLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => handleHover(link));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
